import { useQuery, gql } from "@apollo/client"
import { EntryScreen } from "./EntryScreen"
import { LoadingIcon } from "../svgIcons"
// Client Entry Queries

import {
  mainFileUploadsAssets,
  svgIconsAssets,
} from "../../gatsby-fragments/assets"

import {
  audienceCardsContentBlockType,
  buttonsContentBlockType,
  cardsBlockType,
  ctaContentBlockType,
  embeddedCodeBlockType,
  faqListContentBlockType,
  featuredCardContentBlockType,
  featuredCaseStudiesBlockType,
  featuredEventsContentBlockType,
  featuredResourcesBlockType,
  fullImageContentBlockType,
  iconBarContentBlockType,
  latestResourcesBlockType,
  profileListContentBlockType,
  pullQuoteContentBlockType,
  richContentContentBlockType,
  sectionHeaderContentBlockType,
  sponsorListContentBlockType,
  statsContentBlockType,
  testimonialListContentBlockType,
  upcomingEventsContentBlockType,
  videoContentBlockType,
} from "../../gatsby-fragments/blocks"

import {
  audienceCardEntry,
  basicPageEntry,
  caseStudiesDefaultEntry,
  caseStudiesListingEntry,
  defaultCTAEntry,
  eventEntry,
  faqEntry,
  heroEntry,
  homeEntry,
  landingPageEntry,
  profileEntry,
  resourcesDefaultEntry,
  resourcesListingEntry,
  sponsorEntry,
  testimonialEntry,
} from "../../gatsby-fragments/entries"

import { entrySEO } from "../../gatsby-fragments/entrySEO"
import { dump } from "../../utils/dump"

const PREVIEW_QUERY = gql`
  ${mainFileUploadsAssets}
  ${svgIconsAssets}
  ${audienceCardsContentBlockType}
  ${buttonsContentBlockType}
  ${cardsBlockType}
  ${ctaContentBlockType}
  ${embeddedCodeBlockType}
  ${faqListContentBlockType}
  ${featuredCardContentBlockType}
  ${featuredCaseStudiesBlockType}
  ${featuredEventsContentBlockType}
  ${featuredResourcesBlockType}
  ${fullImageContentBlockType}
  ${iconBarContentBlockType}
  ${latestResourcesBlockType}
  ${profileListContentBlockType}
  ${pullQuoteContentBlockType}
  ${richContentContentBlockType}
  ${sectionHeaderContentBlockType}
  ${sponsorListContentBlockType}
  ${statsContentBlockType}
  ${testimonialListContentBlockType}
  ${upcomingEventsContentBlockType}
  ${videoContentBlockType}

  ${audienceCardEntry}
  ${basicPageEntry}
  ${caseStudiesDefaultEntry}
  ${caseStudiesListingEntry}
  ${defaultCTAEntry}
  ${eventEntry}
  ${faqEntry}
  ${heroEntry}
  ${homeEntry}
  ${landingPageEntry}
  ${profileEntry}
  ${resourcesDefaultEntry}
  ${resourcesListingEntry}
  ${sponsorEntry}
  ${testimonialEntry}

  ${entrySEO}

  query PreviewQuery($entryUri: [String!]) {
    entry(uri: $entryUri, limit: 1) {
      uid
      title
      uri
      sectionHandle
      typeHandle
      ...homeEntry
      ...basicPageEntry
      ...landingPageEntry
      ...resourcesListingEntry
      ...caseStudiesListingEntry
      ...profileEntrySummary
      ...profileEntryPage
      ...resourcesDefaultEntry
      ...caseStudiesDefaultEntry
    }
  }
`

export const PreviewScreen = ({ entryUri }) => {
  const { loading, error, data } = useQuery(PREVIEW_QUERY, {
    variables: {
      entryUri,
    },
  })

  if (loading)
    return (
      <div className="flex items-center justify-center w-screen h-screen bg-blue-500">
        <LoadingIcon className="w-16 h-16 mr-3 -ml-1 text-white animate-spin" />
      </div>
    )

  if (error)
    return (
      <div>
        <h1>Error</h1>
        {dump(error)}
      </div>
    )

  return <EntryScreen entry={data?.entry} />
}
